import axios from '@/utils/http';
import qs from 'qs';

export default (id, rank, tags, remark) => {
  const params = {
    rank,
  };
  if (rank === '1' && tags.length > 0) {
    params.tags = tags;
  }
  if (tags.includes('other')) {
    params.remark = remark;
  }
  return axios
    .post(
      `/multisig_orders/${id}/evaluation`,
      qs.stringify(params, { arrayFormat: 'indices' }),
    )
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
